module.exports = function() {
  return new Worker(__webpack_public_path__ + "735c203b3633d99b825c.worker.js");
};